import React from 'react'
import { useIntl } from 'react-intl'
import { Maybe } from '../../common/types'
import { Item, ItemGroup } from '../../containers/Parameters/types'
import { Button } from '../Button'
import { FormButton } from '../layout/form/FormButton'
import { SelectInput } from '../layout/form/input'
import { convertItemToJobItem } from './convertItemToJobItem'
import { newItem } from './defaults'
import { ToolbarWrapper } from './styled'
import { JobItemInput } from './types'
import SkeletonLoader from '../AlArcCodesForm'
import { messages } from './messages'
import { formatMessageSafe } from '../../util/translateInputOptions'

interface Props {
  items: Maybe<Item[]>
  itemGroups: Maybe<ItemGroup[]>
  createJobItem: (item: JobItemInput) => void
  createDiscountItem: () => void
  hasDiscountItem: boolean
  itemsIncludeVat: boolean
  setIncludeVat: (includeVat: boolean) => void
  disabled?: boolean
  loadingItemGroups: boolean
  loadingItems: boolean
}

export const JobItemToolbar: React.FunctionComponent<Props> = ({
  createJobItem,
  createDiscountItem,
  items,
  itemGroups,
  hasDiscountItem,
  itemsIncludeVat,
  setIncludeVat,
  disabled = false,
  loadingItemGroups = false,
  loadingItems = false
}) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const itemGroupOptions = itemGroups ? itemGroups.map(group => ({ value: group.id, label: group.name })) : []
  const itemOptions = items ? items.map(item => ({ value: item.id, label: item.name })) : []

  return (
    <ToolbarWrapper>
      <JobItemSelectInput
        placeholder={formatMessage(messages.addItemGroupPlaceholder)}
        clearable
        name="itemGroup"
        disabled={disabled}
        options={itemGroupOptions}
        loading={loadingItemGroups || loadingItems}
        onChange={groupId => {
          if (items) {
            for (const item of items) {
              if (item.groups && item.groups.find(group => group === groupId)) {
                createJobItem(convertItemToJobItem(item))
              }
            }
          }
        }}
      />
      <JobItemSelectInput
        placeholder={formatMessage(messages.addItemPlaceholder)}
        clearable
        name="item"
        disabled={disabled}
        options={itemOptions}
        loading={loadingItems}
        onChange={itemId => {
          const item = items && items.find(i => i.id === itemId)
          if (item) {
            createJobItem(convertItemToJobItem(item))
          }
        }}
      />
      <Button
        label={formatMessage(messages.addDiscount)}
        category="regular"
        onClick={createDiscountItem}
        disabled={hasDiscountItem || disabled}
      />

      <FormButton
        label={formatMessage(messages.emptyRow)}
        name="newItem"
        category="new"
        onClick={() => createJobItem(newItem)}
        disabled={disabled}
      />
      <Button
        label={itemsIncludeVat ? formatMessage(messages.pricesIncludeVat) : formatMessage(messages.pricesExcludeVat)}
        category={itemsIncludeVat ? 'on' : 'off'}
        onClick={() => setIncludeVat(!itemsIncludeVat)}
        disabled={disabled}
      />
    </ToolbarWrapper>
  )
}


interface OptionItem {
  value: number;
  label: string;
}
interface LoadingInputProps {
  options: OptionItem[]
  disabled: boolean
  loading: boolean
  onChange: (value: any) => void
  clearable?: boolean
  placeholder?: string
  name: string
}

const JobItemSelectInput = ({ options, disabled, onChange, loading, clearable = true, placeholder, name }: LoadingInputProps) => {

  if (loading) {
    return <SkeletonLoader text="" />
  }

  return options.length ? (
    <SelectInput
      placeholder={placeholder}
      name={name}
      label={''}
      options={options}
      clearable={clearable}
      disabled={disabled}
      onChange={onChange}
    />
  ) : null
}